import DTOFilledQuestionField = namaTypes.DTOFilledQuestionField;
import ListLayoutPreferences = namaTypes.ListLayoutPreferences;
import UIPreferences = namaTypes.UIPreferences;
import DTOCriteria = namaTypes.DTOCriteria;
import EditScreenLayout = namaTypes.EditScreenLayout;
import MetaData from "@/utils/common/MetaData.ts";
import ClientCache from "@/utils/login/ClientCache.ts";
import NamaCommon from "@/utils/common/NamaCommon.ts";
import NamaURLS from "@/utils/constants/NamaURLS.ts";

export default class CacheUtil {
  static getCachedQuestionFields(entityType: string, listViewName: string | undefined): DTOFilledQuestionField[] {
    let cachedListLayoutPreferences: ListLayoutPreferences | undefined = this.getCachedListLayoutPreferences(entityType);
    if (cachedListLayoutPreferences && MetaData.isTheSameLayout(cachedListLayoutPreferences.layoutId, listViewName))
      return cachedListLayoutPreferences.questionFields ?? [];
    return [];
  }

  static getCachedCriteria(entityType: string, listViewName: string | undefined): DTOCriteria | undefined {
    let cachedListLayoutPreferences: ListLayoutPreferences | undefined = this.getCachedListLayoutPreferences(entityType);
    if (cachedListLayoutPreferences && MetaData.isTheSameLayout(cachedListLayoutPreferences.layoutId, listViewName))
      return cachedListLayoutPreferences.criteria;
    return undefined;
  }

  static getCachedListLayoutPreferences(entityType: string): ListLayoutPreferences | undefined {
    let uiPreferences = ClientCache.uiPreferencesCache[entityType];
    if (uiPreferences && uiPreferences.listLayoutPreferences)
      return uiPreferences.listLayoutPreferences;
    return undefined;
  }

  static getCachedOrderBy(entityType: string, listViewName: string | undefined): string | undefined {
    let cachedListLayoutPreferences: ListLayoutPreferences | undefined = this.getCachedListLayoutPreferences(entityType);
    if (cachedListLayoutPreferences && MetaData.isTheSameLayout(cachedListLayoutPreferences.layoutId, listViewName))
      return cachedListLayoutPreferences.sortBy;
    return undefined;
  }

  static async fetchTermScreen(documentType: string): Promise<EditScreenLayout | null | undefined> {
    if (!documentType)
      return null;
    if (ClientCache.termsAndConfigScreens.hasOwnProperty(documentType))
      return ClientCache.termsAndConfigScreens[documentType];
    let screen = await NamaCommon.namaFetch(NamaURLS.FetchSingleDocumentTermScreen, {params: {documentType}})
    ClientCache.termsAndConfigScreens[documentType] = screen.data;
    return screen.data;
  }

  static async fetchConfigEntryScreen(configProperty: string) {
    if (ClientCache.termsAndConfigScreens.hasOwnProperty(configProperty))
      return ClientCache.termsAndConfigScreens[configProperty];
    let screen = await NamaCommon.namaFetch(NamaURLS.FetchSingleConfigEntryScreen, {params: {configProperty}})
    ClientCache.termsAndConfigScreens[configProperty] = screen.data;
    return screen.data;
  }
}
